// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { OrderManualPaymentsDTO } from '../models';
/**
 * OrderManualPaymentsApi - axios parameter creator
 * @export
 */
export const OrderManualPaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets manual payments for a claim with linked source details
         * @param {string} claimId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderManualPaymentsByClaim(claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling getOrderManualPaymentsByClaim.');
            }
            const localVarPath = `/v2/order-manual-payments/claims/{claimId}`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderManualPaymentsApi - functional programming interface
 * @export
 */
export const OrderManualPaymentsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Gets manual payments for a claim with linked source details
         * @param {string} claimId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderManualPaymentsByClaim(claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderManualPaymentsDTO> {
            const localVarAxiosArgs = OrderManualPaymentsApiAxiosParamCreator(configuration).getOrderManualPaymentsByClaim(claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * OrderManualPaymentsApi - factory interface
 * @export
 */
export const OrderManualPaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Gets manual payments for a claim with linked source details
         * @param {string} claimId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderManualPaymentsByClaim(claimId: string, options?: any) {
            return OrderManualPaymentsApiFp(configuration).getOrderManualPaymentsByClaim(claimId, options)(axios, basePath);
        },
    };
};

/**
 * OrderManualPaymentsApi - interface
 * @export
 * @interface OrderManualPaymentsApi
 */
export interface OrderManualPaymentsApiInterface {
    /**
     * Gets manual payments for a claim with linked source details
     * @param {string} claimId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderManualPaymentsApiInterface
     */
    getOrderManualPaymentsByClaim(claimId: string, options?: any): AxiosPromise<OrderManualPaymentsDTO>;

}

/**
 * OrderManualPaymentsApi - object-oriented interface
 * @export
 * @class OrderManualPaymentsApi
 * @extends {BaseAPI}
 */
export class OrderManualPaymentsApi extends BaseAPI implements OrderManualPaymentsApiInterface {
    /**
     * Gets manual payments for a claim with linked source details
     * @param {string} claimId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderManualPaymentsApi
     */
    public getOrderManualPaymentsByClaim(claimId: string, options?: any) {
        return OrderManualPaymentsApiFp(this.configuration).getOrderManualPaymentsByClaim(claimId, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for OrderManualPaymentsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Gets manual payments for a claim with linked source details
 * @param {string} claimId 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getOrderManualPaymentsByClaim(
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrderManualPaymentsDTO> {
    const localVarAxiosArgs = OrderManualPaymentsApiAxiosParamCreator(configuration).getOrderManualPaymentsByClaim(claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

